<div id="card-container" *loading="statCardsLoadStatus">
    <mat-card *ngFor="let stat of statsCards" class="stat-card">
      <stat-card [icon]="stat.icon" [label]="stat.label" [sublabel]="stat.sublabel"></stat-card>
    </mat-card>
</div>
<div id="popular-course-container">
  <div id="filter-container">
    <label id="popular-filter-label">Most Popular {{ hub.mode | courseLabel:true | titlecase }}:</label>
    <mat-radio-group aria-labelledby="popular-filter-label" class="popular-filter-radio-group" [(ngModel)]="selectedFilter" (change)="updatePopularExperiences()">
      <mat-radio-button value="visitors">
        Nb of Visitors
      </mat-radio-button>
      <mat-radio-button value="sessions">
        Nb of Sessions
      </mat-radio-button>
      <!-- <mat-radio-button value="avgtimespent">
        Time Spent Per Session
      </mat-radio-button> -->
      <mat-radio-button value="ai">
        AI Usage
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div id="popular-course-list">
    <hub-experience-card *ngFor="let course of popularCourses" [hub]="hub" [course_id]="course.id" [date_from]="date_from" [date_to]="date_to"></hub-experience-card>
</div>
</div>
